import type { Estimate } from "../api";

/**
 * What narrating a chapter now would do to its parts: carry some over as they
 * are, re-level some already bought (ADR-0178), record the rest. One place, so
 * a new kind of carried part is subtracted once (re-finishing had to be
 * taught to two copies of this sum).
 */
export function partCounts(e: Estimate): {
  reusable: number;
  refinish: number;
  /** Parts kept from the last render, whether as they are or re-levelled. */
  carried: number;
  /** Parts that would be recorded again, and paid for. */
  recorded: number;
  /** Only re-levelling to do: free, and nothing changed by the author. */
  relevelOnly: boolean;
} {
  const refinish = e.refinish ?? 0;
  const carried = e.reusable + refinish;
  return {
    reusable: e.reusable,
    refinish,
    carried,
    recorded: e.chunks - carried,
    relevelOnly: refinish > 0 && carried === e.chunks,
  };
}
